/********************************************
 * Dependencies from other libs and components
 *******************************************/

// === General Libraries & Functions
//
//  import ReactDOM from 'react-dom';
//  import update from 'immutability-helper';
//
import React, { useState, useEffect } from 'react';
import { ORDER_QTY_LEVELS, INSPECTION_LEVELS } from "../../reduxRoot/reducers/aqlCalculatorReducer";
import {connect} from "react-redux";


// === Local Libraries & Functions
//
//  import { wrapStore } from '../../utils/reducerUtils';
//  import { initStore } from './store';
//


/********************************************
 * Main Component
 *******************************************/

const Result = ({
  sampleSize,
  allowedMajor,
  allowedMinor,
}) => {
  return (
    <section className={'aql-calc-result'}>
      <p>Based on the above input, the sample size and the number of allowed defects are as follows:</p>

      <h2>{sampleSize}</h2>
      <p>Samples to inspect</p>

      <h2>0</h2>
      <p>Critical defects</p>

      <h2>{allowedMajor}</h2>
      <p>Samples or less with MAJOR defects</p>

      <h2>{allowedMinor}</h2>
      <p>Samples or less with MINOR defects</p>
    </section>
  );
};

export default connect(
  ({ aqlCalculator: { sampleSize, allowedMajor, allowedMinor } }) => ({ sampleSize, allowedMajor, allowedMinor }),
)(Result);
